const reducer = state => ({
  ...state,
  showExpiredOffersModal: false,
  proposedSlot: undefined,
});

export default reducer;
